import React from 'react'
import BulkActionContext from '../context'

const withBulkAction = WrappedComponent => props => (
  <BulkActionContext.Consumer>
    {value => <WrappedComponent {...value} {...props} />}
  </BulkActionContext.Consumer>
)

export default withBulkAction
